import Footer from 'components/internal/Footer'
import Header from 'components/internal/Header'

const mdx = `<div id="covie-root"></div>
<script>
	window.covieReady = function() {
		Covie.access.init({
			elementId: "covie-root", // embed host goes here
			integrationKey: "%YOUR_INTEGRATION_KEY%",
			linkId: "",
			width: "",
			height: "",
			onInit: function (linkId) {},
			onSuccess: function (linkId, policies) {},
			onStepChange: function (linkId, step) {},
			onLinkError: function (linkId, error) {},
			hide: []
		})
	}
</script>
<script async defer src="https://access.covie.io/sdk/covie-access.js"></script>
`

export default function Docs({ embedHost }) {
  const sdkCode = ``

  return (
    <div className="flex-1">
      <Header />

      <div className="container mx-auto px-8 py-12">
        <article className="prose mx-auto">
          <h1>Documentation</h1>
          <div className="text-xl font-light text-gray-600">
            Follow the instructions below to integrate Covie in minutes.
          </div>
          <hr />
          <h2>Javascript SDK</h2>
          <p>
            Simply copy and paste the code snippet below into your website
            before the closing <code>&lt;/body&gt;</code> tag. Make sure you
            move the <code>covie-root</code> div element into the appropriate
            location as this is where the embed will render.
          </p>
          <pre>
            {mdx.replace(
              '// embed host goes here',
              embedHost ? '\n 			embedHost: "' + embedHost + '",' : ''
            )}
          </pre>
          <h3>Parameters</h3>
          <table cellPadding="10" className="-ml-2">
            <tr valign="top">
              <th width="200">
                elementId
                <br />
                <i className="font-normal">string</i>
              </th>
              <td>Where the embedded iframe will render</td>
            </tr>
            <tr valign="top">
              <th>
                integrationKey
                <br />
                <i className="font-normal">string</i>
              </th>
              <td>Your integration key</td>
            </tr>
            <tr valign="top">
              <th>
                width, height
                <br />
                <i className="font-normal">number</i>
              </th>
              <td>
                Set the desired width and height for the iframe.{' '}
                <p>
                  <b>Note:</b> If either width or height is not passed, the
                  iframe will try to determine the best size.
                </p>
              </td>
            </tr>
            <tr valign="top">
              <th>
                onInit
                <br />
                <i className="font-normal">function</i>
              </th>
              <td>Called once the embed has initialized properly.</td>
            </tr>
            <tr valign="top">
              <th>
                onSuccess
                <br />
                <i className="font-normal">function</i>
              </th>
              <td>
                Called once the user has completed the linking process and
                selected policies.
              </td>
            </tr>
            <tr valign="top">
              <th>
                onStepChange
                <br />
                <i className="font-normal">function</i>
              </th>
              <td>
                Called on each stage transition (e.g. provider_select, login)
              </td>
            </tr>
            <tr valign="top">
              <th>
                onLinkError
                <br />
                <i className="font-normal">function</i>
              </th>
              <td>{`Called when the operation is aborted and the link cannot be completed, as well as when
								a user could not find their provider in the insurance provider list, and submitted a
								report of the issue. For missing provider reports, the "providerName" property is set.`}</td>
            </tr>
            <tr valign="top">
              <th>
                hide
                <br />
                <i className="font-normal">string[]</i>
              </th>
              <td>{`Use to hide elements of the linking process. To hide the "My provider is not listed"
								link at the bottom of the provider selection screen, include "missingProviderSubmission".`}</td>
            </tr>
          </table>
        </article>
      </div>

      <Footer />
    </div>
  )
}

/**
 * Get environment arguments at build time
 */
export async function getStaticProps(context) {
  // Get demo integration key
  return { props: { embedHost: process.env.EMBED_HOST ?? null } }
}
